var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      width: 41,
      height: 40
    },
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6128 14.4563C15.1233 21.3051 17.7224 24.0377 24.3344 26.9482L21.4689 30.9726C13.8763 27.3375 10.0945 21.21 8.31345 16.4282L12.6128 14.4563Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7187 5.00143C16.0612 4.99618 17.0819 6.11323 16.9904 7.37812C16.8464 9.36864 16.9997 10.8048 17.4126 12.5849C17.6393 13.5627 17.1263 14.5558 16.311 15.1955C15.2121 16.0577 14.3726 17.1563 13.7054 18.102C12.7806 19.4128 9.59793 19.3187 8.89409 17.8907C7.44758 14.9559 6.46729 9.54907 8.5796 5.89611C8.9114 5.32232 9.57946 5.02152 10.2717 5.01882L14.7187 5.00143Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0968 26.7183C35.2638 25.4603 34.2123 24.369 32.8716 24.3026C30.7619 24.1983 29.2708 23.8818 27.4492 23.2807C26.4486 22.9505 25.3429 23.312 24.5725 23.9995C23.534 24.9261 22.2782 25.581 21.2038 26.0929C19.7147 26.8023 19.431 29.7975 20.8474 30.6291C23.7584 32.3383 29.3241 33.9076 33.418 32.3665C34.0611 32.1244 34.4576 31.5342 34.5437 30.8855L35.0968 26.7183Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.7e47fb2c4f158a699210d63784d97e94.svg";
export { ForwardRef as ReactComponent };